import { IDestination, transformDestination } from '~/src/dash/api/inventory_routes';
import { addDomainAndTokenToUrl, IHttpResponse, restGet } from '~/src/dash/api/rest';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IMenuList } from '~/src/dash/types/menuList';

export async function getDestinationsMenuList(
  session: ISessionState,
): Promise<Record<string, IMenuList>> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${session.publisher.ID}/destinations`);
  return await restGet<any>(reqUrl, {})
    .then((val: IHttpResponse<any>) => {
      const destinations = val.parsedBody?.map(transformDestination);
      return {
        destinations: generateInventoryDestinationMenuList(destinations),
      };
    })
    .catch((e) => {
      console.error(e);
      return {
        destinations: {},
      };
    });
}

function generateInventoryDestinationMenuList(destinations: IDestination[]) {
  const menuList = {} as IMenuList;

  destinations.forEach((destination) => {
    menuList[destination.ID] = {
      ID: String(destination.ID),
      title: destination.Name,
      selected: false,
    };
  });

  return menuList;
}
